'use client';
/** @jsxImportSource @emotion/react */

import React, { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiAccordion, {
  type AccordionTypeMap as MuiAccordionTypeMap,
} from '@mui/material/Accordion';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type AccordionTypeMap<
  P = CustomProps,
  D extends ElementType = MuiAccordionTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiAccordionTypeMap['props'], ExcludedMuiProps> & P;
};

export type AccordionProps<
  D extends ElementType = MuiAccordionTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiAccordionTypeMap<P, D>, D>;

const AccordionComponent = (
  props: AccordionProps,
  ref: Ref<HTMLDivElement>
) => {
  return <MuiAccordion {...props} ref={ref} />;
};

AccordionComponent.displayName = 'Accordion';

export const Accordion = forwardRef(
  AccordionComponent
) as OverridableComponent<AccordionTypeMap>;
